import usePageTitle from "../hooks/usePageTitle";

function UnAuthorizedPage() {
    // Update page title
    usePageTitle();
    
    return (
        <div>
            UnAuthorized Page
        </div>
    )
}

export default UnAuthorizedPage;
